import config from '../../config'

const persister = (next) => {
    return (reducer, initialState, enhancer) => {
        const key = config.name.replace(/\s+/g, '_')
            .toLowerCase()
        // Load the state from local storage.
        let newInitialState = initialState
        try {
            const stored = localStorage.getItem(key)
            if (stored) {
                const persistedState = JSON.parse(stored)
                newInitialState = { ...initialState, ...persistedState }
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Failed to load state.', error)
        }
        const store = next(reducer, newInitialState, enhancer)

        // Store the state in local storage after every change.
        store.subscribe(() => {
            const state = store.getState()
            try {
                localStorage.setItem(key, JSON.stringify(state))
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn('Failed to persist state.', error)
            }
        })
        return store
    }
}

export default persister



// WEBPACK FOOTER //
// ./src/store/enhancers/persister.js